module.exports = __webpack_public_path__ + "media/images/ic-map-circle-selected-35e78e4b.svg";